import DataConst from 'consts/DataConst';
import BaseController from './BaseController';

class OrderController extends BaseController {
  model = DataConst.MODELS.ORDER;
}

export default new OrderController();
